import { useEffect, useState } from 'react';
import _ from 'lodash';
import { Item, fetchItem } from 'services/items';
import { Tag, fetchTagsAPI } from 'services/tags';
import { ReportPreset, fetchReportPresets, ReportId } from 'services/reports';
import { pickAdvancedSearchFieldsCombined } from '../consts';

interface PickingPageDataProps {
  advancedSearchColumns: Record<string, any> | undefined;
  activeUserId: number;
}

interface PickingPageDataResult {
  searchItem: Item | null;
  searchTags: Tag[];
  reportPresets: ReportPreset[];
}

export const usePickingPageData = ({
  advancedSearchColumns,
  activeUserId,
}: PickingPageDataProps): PickingPageDataResult => {
  const [searchItem, setSearchItem] = useState<Item | null>(null);
  const [searchTags, setSearchTags] = useState<Tag[]>([]);
  const [reportPresets, setReportPresets] = useState<ReportPreset[]>([]);

  const itemId = _.get(
    advancedSearchColumns,
    [pickAdvancedSearchFieldsCombined.Item],
    null
  ) as number | null;

  const tagIdsRaw = _.get(
    advancedSearchColumns,
    [pickAdvancedSearchFieldsCombined.Tags],
    null
  ) as number[] | null;
  const stringifiedTagIds = JSON.stringify(tagIdsRaw);

  useEffect(() => {
    const currentItemId = itemId;

    if (currentItemId) {
      setSearchItem(null);
      (async () => {
        try {
          const resItem = await fetchItem(currentItemId);
          setSearchItem(resItem);
        } catch (error) {
          console.error('Failed to fetch search item:', error);
          setSearchItem(null);
        }
      })();
    } else {
      setSearchItem(null);
    }
  }, [itemId]);

  useEffect(() => {
    if (activeUserId && activeUserId !== 0) {
      (async () => {
        try {
          const res = await fetchReportPresets(activeUserId, ReportId.Pick);
          setReportPresets(res);
        } catch (error) {
          console.error('Failed to fetch report presets:', error);
          setReportPresets([]);
        }
      })();
    } else {
      setReportPresets([]);
    }
  }, [activeUserId]);

  useEffect(() => {
    const currentTagIds = JSON.parse(stringifiedTagIds) as number[] | null;

    if (currentTagIds && currentTagIds.length > 0) {
      setSearchTags([]);
      (async () => {
        try {
          const resTags = await fetchTagsAPI({}, currentTagIds);
          setSearchTags(resTags.data);
        } catch (error) {
          console.error('Failed to fetch search tags:', error);
          setSearchTags([]);
        }
      })();
    } else {
      setSearchTags([]);
    }
  }, [stringifiedTagIds]);

  return { searchItem, searchTags, reportPresets };
};
